import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';

export default function CancelarRemates() {
  const [params] = useSearchParams();
  const id = params.get('id');
  const token = params.get('token');
  const [estado, setEstado] = useState('cargando'); // cargando | ok | noEncontrada | error

  useEffect(() => {
    if (!id && !token) { setEstado('noEncontrada'); return; }
    const cancelar = async () => {
      try {
        // Baja directa por ID (la regla permite poner activa:false sin leer).
        if (id) {
          await updateDoc(doc(db, 'suscripcionesRemates', id), { activa: false, canceladaEn: new Date() });
          setEstado('ok');
          return;
        }
        // Fallback por token (requiere lectura, solo admin).
        const q = query(collection(db, 'suscripcionesRemates'), where('token', '==', token));
        const snap = await getDocs(q);
        if (snap.empty) { setEstado('noEncontrada'); return; }
        await updateDoc(doc(db, 'suscripcionesRemates', snap.docs[0].id), { activa: false, canceladaEn: new Date() });
        setEstado('ok');
      } catch {
        setEstado('error');
      }
    };
    cancelar();
  }, [id, token]);

  const contenido = {
    cargando:     { icon: '⏳', titulo: 'Procesando...', msg: 'Estamos cancelando tu suscripción.', color: '#555' },
    ok:           { icon: '✅', titulo: '¡Suscripción cancelada!', msg: 'Ya no recibirás más avisos de nuevos remates.', color: '#155724' },
    noEncontrada: { icon: '🔍', titulo: 'Link inválido', msg: 'No encontramos ninguna suscripción asociada a este enlace.', color: '#856404' },
    error:        { icon: '❌', titulo: 'Error', msg: 'No pudimos procesar la cancelación. Intentá de nuevo más tarde.', color: '#721c24' },
  }[estado];

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
      <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 8px 30px rgba(0,0,0,0.1)', padding: '48px 40px', maxWidth: '440px', width: '100%', textAlign: 'center' }}>
        <p style={{ fontSize: '52px', margin: '0 0 16px' }}>{contenido.icon}</p>
        <h2 style={{ margin: '0 0 12px', fontSize: '22px', color: contenido.color }}>{contenido.titulo}</h2>
        <p style={{ color: '#666', fontSize: '15px', margin: '0 0 28px', lineHeight: 1.6 }}>{contenido.msg}</p>
        <Link to="/remates" style={{ display: 'inline-block', padding: '12px 28px', background: '#1a1a2e', color: 'white', borderRadius: '8px', textDecoration: 'none', fontWeight: 'bold', fontSize: '14px' }}>
          Ver la agenda de remates →
        </Link>
      </div>
    </div>
  );
}
